import type { CellContent, CellSection } from "./contentItemSchemas";
import { CONTENT_ITEM_KEYS } from "@/constants/contentItemKeys";
import { isRecord } from "./shared";
import { parseImageContent, parsePersonalizedImageContent } from "./image";
import { parseTextContent } from "./text";
import {
  cellSectionFieldsSchema,
  parseCellSectionFromFields,
  parseWithRecord,
} from "./schemas";

export const parseCellContent = (item: unknown): CellContent => {
  if (!isRecord(item))
    return parseTextContent({ [CONTENT_ITEM_KEYS.TEXT]: "" });
  if (CONTENT_ITEM_KEYS.IMAGE in item && !(CONTENT_ITEM_KEYS.WIDTH in item))
    return parseImageContent(item);
  if (CONTENT_ITEM_KEYS.IMAGE in item && CONTENT_ITEM_KEYS.WIDTH in item)
    return parsePersonalizedImageContent(item);
  if (CONTENT_ITEM_KEYS.TEXT in item) return parseTextContent(item);
  return parseTextContent({ [CONTENT_ITEM_KEYS.TEXT]: "" });
};

export const parseCellSection = (item: unknown): CellSection => {
  const parsed = parseWithRecord(item, cellSectionFieldsSchema);
  const contentArray: unknown[] = Array.isArray(parsed.content)
    ? parsed.content
    : [];
  const content: CellContent[] = contentArray.map((cell: unknown) =>
    parseCellContent(cell),
  );
  return parseCellSectionFromFields(parsed, content);
};
